import Immutable from 'immutable';
import moment from 'moment';
import React from 'react';

import TableContainer from 'sharedreact/containers/TableContainer';
import SortOrder from 'sharedreact/data/SortOrder';
import type TableColumn from 'sharedreact/data/TableColumn';
import type { RangeType } from 'sharedreact/stores/generic/Type';
import { translate } from 'sharedreact/utils/LanguageSupport';

import type AuditRecord from 'sharedreact/data/AuditRecord';

type Props = {
  language: string,
  auditRecords: Immutable.List<AuditRecord | null>,
  sortOrder: SortOrder,

  setVisibleRange: (visibleRange: RangeType) => void,
  onSortOrderChange: (sortOrder: SortOrder) => void,

  emptyTableText?: string,
};

class AuditTable extends React.Component<Props> {
  override render (): React.ReactNode {
    const {
      language, // eslint-disable-line no-unused-vars
      auditRecords,
      sortOrder,
      setVisibleRange,
      onSortOrderChange,
      emptyTableText
    } = this.props;

    const tableColumns: Immutable.List<TableColumn<AuditRecord>> = Immutable.List([ {
      title: translate('launcher.audit.table.modificationdate'),
      width: '15%',
      renderCell: (item: AuditRecord, row: number, col: number) =>
      (
        (item.modificationDate != null && moment.isMoment(item.modificationDate))
          ? item.modificationDate.locale(moment.locale()).format('LLL') : ''
      ),
      sortOrderKeyword: 'modificationdate',
      selectable: false,
      movable: true,
      name: 'modificationdate'
    }, {
      title: translate('launcher.audit.table.username'),
      width: '15%',
      renderCell: (item: AuditRecord, row: number, col: number) => item.userName,
      sortOrderKeyword: 'username',
      selectable: true,
      movable: true,
      name: 'username'
    }, {
      title: translate('launcher.audit.table.eventtype'),
      width: '10%',
      renderCell: (item: AuditRecord, row: number, col: number) => item.localizedType,
      selectable: true,
      movable: true,
      default: false,
      name: 'eventtype'
    }, {
      title: translate('launcher.audit.table.category'),
      width: '10%',
      renderCell: (item: AuditRecord, row: number, col: number) => item.localizedCategory,
      selectable: true,
      movable: true,
      name: 'category'
    }, {
      title: translate('launcher.audit.table.details'),
      width: '50%',
      renderCell: (item: AuditRecord, row: number, col: number) => item.getLocalizedDetails(true),
      selectable: true,
      movable: true,
      name: 'details'
    }]);

    return (
      <TableContainer<AuditRecord>
        id='launcher_audit_table'
        tableName='AuditTable'
        rowData={auditRecords}
        tableColumns={tableColumns}
        sortOrder={sortOrder}
        setVisibleRange={setVisibleRange}
        onSortOrderChange={onSortOrderChange}
        emptyTableText={emptyTableText}
      />
    );
  }
}

export default AuditTable;
